import { TriggerHistoryElement } from './TriggerHistoryElement';

export class RegexTriggerElement extends TriggerHistoryElement {
  constructor() {
    super();
  }
}
